<template>
  <!-- 登录统计 -->
  <div class="loginList">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['数据分析',$route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData">导出数据</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          v-model="searchForm.start"
          clearable 
          style="width:200px;margin-right:5px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期">
        </el-date-picker>
        <el-date-picker
          type="date"
          v-model="searchForm.end"
          clearable
          style="width:200px;margin-right:5px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择结束日期">
        </el-date-picker>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入编号/名称" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="UserID"
        show-overflow-tooltip
        label="客户ID">
      </el-table-column>
      <el-table-column
        align="center"
        prop="businesscode"
        show-overflow-tooltip
        label="公司编号">
      </el-table-column>
      <el-table-column
        align="center"
        prop="businessname"
        show-overflow-tooltip
        label="公司名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="Addr"
        show-overflow-tooltip
        label="地址">
      </el-table-column>
      <el-table-column
        align="center"
        prop="lastmodifytime"
        show-overflow-tooltip
        label="登录时间">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>

export default {
  name: 'loginList',
  data() {
    return {
      /**表格数据 */
      tableData:[],
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      /**搜索表单 */
      searchForm:{
        start: this.$formatDate(new Date().getTime() - 2592000000),
        end: this.$formatDate(new Date()),
        name: ''
      }
    }
  },
  mounted(){
    this.getTableData()
  },
  methods:{
    /**获取表格 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      if(!this.searchForm.start){
        this.$message({
          message: '请输入开始时间',
          type: 'warning'
        });
        return
      }
      if(!this.searchForm.end){
        this.$message({
          message: '请输入结束时间',
          type: 'warning'
        });
        return
      }
      let data = {
        type: "MemberLog",
        Procedure: "Proc_HjSalesMan",
        entId: window.localStorage.getItem('entId'),
        SqlValue: this.searchForm.name,
        KsRq: this.searchForm.start,
        JsRq: this.searchForm.end,
        PageSize: this.pageSize + '',
        PageIndex: this.currPage + ''
      };
      let type = "DataTable"
      this.$requestSys({
        url: "FactoryClerk/ashx/ReturnDataTable.ashx?Type=" + type + "&Json=" + encodeURI(JSON.stringify(data)),
        method: "Post",
      }).then((res) => {
        window.console.log(res);
        this.tableData = [];
        if (res.return_code == 0) {
          this.allPage = res.recordCount;
          this.tableData = res.data
          // .map(item => ({
          //   id: item.UserID, // 客户编号
          //   name: item.businessname, // 客户名称
          //   num: item.Unum, // 登录次数
          //   orderNum: item.Onum, // 下单次数
          // }))
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    exportData(){
      let data = {
        type: "MemberLog",
        userId: window.localStorage.getItem('userId'),
        entId: window.localStorage.getItem('entId'),
        SqlValue: this.searchForm.name,
        KsRq: this.searchForm.start,
        JsRq: this.searchForm.end,
        PageSize: 9999999,
        PageIndex: 1
      }
      let proc = "Proc_HjSalesMan"
      window.location.href = this.baseUrl + "Order/NoPIGExprot?json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + encodeURIComponent(proc) + "&name=登录统计"
    },
  }
}
</script>

<style scoped>
.loginList{
  width: 100%;
  height: 100%;
}
</style>
